// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.u64().primaryKey(),
  user1Id: __t.u64().name("user1_id"),
  user2Id: __t.u64().name("user2_id"),
  lastMessageAt: __t.u64().name("last_message_at"),
  user1UnreadCount: __t.u32().name("user1_unread_count"),
  user2UnreadCount: __t.u32().name("user2_unread_count"),
});
